/**
 * Check if this is an "Everyone" recipe that doesn't have user data yet
 *
 * @type {Boolean}
 */
const isEveryoneRecipeWithoutUserData = () => {
	return UncannyAutomator._recipe.recipe_type == 'anonymous' && ! UncannyAutomator.recipe.requiresUserData;
}

export default isEveryoneRecipeWithoutUserData;